import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  Collapsible,
  ColorPicker,
  Layout,
  InlineStack,
  BlockStack,
  TextField,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Content = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, CONTENT, DEFAULT_CONTENT_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.contentColor.title")}
        description={cms("section.contentColor.description")}
      >
        <Card
          title={[
            cms("section.contentColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.contentColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.contentColor.label.hexCode")}
                    value={hex.contentHex}
                    onChange={(value) => handleChange(CONTENT, value, HEX)}
                    labelAction={
                      hex.contentHex !== DEFAULT_CONTENT_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(CONTENT, DEFAULT_CONTENT_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.content}
                  />
                  <br />
                  <Text as="span" variant="bodySm">
                    <div
                      style={{
                        borderRadius: ".5rem",
                        width: "max-content",
                        height: "28px",
                        color: hex.contentHex,
                        textAlign: "center",
                        padding: "6px 12px",
                      }}
                    >
                      {cms("section.contentColor.label.sampleHeader")}
                    </div>
                  </Text>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(CONTENT, value, COLOR)} color={color.contentColor} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(Content);
